import { isFunction } from './isFunction';
import { isClass } from './isClass';

export function isNonClassFunction(obj: any) {
  return isFunction(obj) && !isClass(obj);
}
